import { render, staticRenderFns } from "./ClusterReport.vue?vue&type=template&id=1f24d162&scoped=true&"
import script from "./ClusterReport.vue?vue&type=script&lang=ts&"
export * from "./ClusterReport.vue?vue&type=script&lang=ts&"
import style0 from "./ClusterReport.vue?vue&type=style&index=0&id=1f24d162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f24d162",
  null
  
)

export default component.exports